var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.37498 22.9166C9.95028 22.9166 10.4166 22.4502 10.4166 21.8749C10.4166 21.2996 9.95028 20.8333 9.37498 20.8333C8.79968 20.8333 8.33331 21.2996 8.33331 21.8749C8.33331 22.4502 8.79968 22.9166 9.37498 22.9166Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8334 22.9166C21.4087 22.9166 21.875 22.4502 21.875 21.8749C21.875 21.2996 21.4087 20.8333 20.8334 20.8333C20.2581 20.8333 19.7917 21.2996 19.7917 21.8749C19.7917 22.4502 20.2581 22.9166 20.8334 22.9166Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.04169 1.04175H5.20835L8.00002 14.9897C8.09527 15.4692 8.35617 15.9 8.73705 16.2066C9.11792 16.5132 9.5945 16.6761 10.0834 16.6667H20.2084C20.6972 16.6761 21.1738 16.5132 21.5547 16.2066C21.9355 15.9 22.1964 15.4692 22.2917 14.9897L23.9584 6.25008H6.25002",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart);
export default __webpack_public_path__ + "static/media/shopping-cart.f6378a5efe467032c99d2b4c2f5f1ea0.svg";
export { ForwardRef as ReactComponent };